<template>
  <v-container grid-list-md text-xs-left v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-layout row>
      <v-flex xs12>
        <h1 class="text-xs-left ma-3">{{title}}</h1>
      </v-flex>
    </v-layout>

    <div v-if="notificationList !== null ? notificationList.length > 0 : false">
      <v-layout row class="mx-3">
        <v-flex xs12>
          <template>
            <v-data-table
                :headers="headers"
                :items="notificationList"
                hide-actions
                class="elevation-1"
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">
                  <span class="cursor-pointer" @click="$router.push('/notifications/single/' + props.item.id)">{{props.item.title}}</span>
                </td>
                <td class="text-xs-left">{{ $moment(props.item.planned_send_datetime).format('D MMM YYYY, HH:mm') }}</td>
                <td class="text-xs-left">{{ props.item.description }}</td>
                <td class="text-xs-left">{{ props.item.branch !== null ? props.item.branch.title : '' }}</td>
                <td class="text-xs-left">{{ props.item.sale_group !== null ? props.item.sale_group.title : '' }}</td>
                <td class="text-xs-left">{{ props.item.user_group !== null ? props.item.user_group.title : '' }}</td>
                <td class="text-xs-left">
                  <div v-if="mode === 'future'">
                    <v-btn
                        flat
                        icon
                        class="ma-1"
                        @click="editNotification(props.item.id)"
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn
                        flat
                        icon
                        class="ma-1"
                        @click="deleteNotification(props.item.id)"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </div>
                </td>
              </template>
            </v-data-table>
          </template>
        </v-flex>
      </v-layout>
    </div>


    <div v-if="mode === 'future' && notificationList !== null ? notificationList.length === 0 : false">
      <div class="ml-3 subheading">Нет планируемых сообщений. <span @click="$router.push('/notifications/new')" class="cursor-pointer primary--text">Добавить новое</span></div>
    </div>

    <div v-if="mode === 'past' && notificationList !== null ? notificationList.length === 0 : false">
      <div class="ml-3 subheading">Нет архивных сообщений.</div>
    </div>

    <v-layout row v-if="pages > 1">
      <v-flex xs12>
        <div class="text-xs-left mt-3">
          <v-pagination
              v-model="page"
              :length="pages"
              :total-visible="7"
              @input="changePage()"
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout>

    <v-dialog
        v-model="deleteDialog"
        max-width="300"
        v-if="mode === 'future'"
    >
      <v-card>
        <v-card-title class="headline">Удалить уведомление?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              color="error"
              @click="deleteNotificationConfirm(deleteNotificationId)"
          >
            Удалить
          </v-btn>

          <v-btn
              @click="deleteNotificationCancel()"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
  import HelpMixin from '../../mixins/help'

  export default {
    mixins: [HelpMixin],
    data () {
      return {
        breadcrumbs: [
          {name: 'Главная', link: '/'},
          {name: 'Сообщения'}
        ],
        headers: [
          {
            text: 'Название',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Дата отправки',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Текст',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Филиал',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Супервайзер',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Группа',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Действия',
            align: 'left',
            sortable: false,
            value: 'name'
          }
        ],
        pageDataReady: {
          isReady: false,
          notificationList: false
        },
        page: 1,
        mode: 'future',
        title: 'Планируемые сообщения',
        deleteDialog: false,
        deleteNotificationId: null
      }
    },
    methods: {
      pageDataStatus () {
        if (!this.pageDataReady.notificationList) {
          return false
        }
        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      changePage () {
        this.scrollUp()
        this.pageDataReady = {
          isReady: false,
          notificationList: false
        }
        this.$store.commit('setPageLoading', true)

        if (this.mode === 'past') {
          this.$router.push('/notifications/past/' + this.page)
        } else if (this.mode === 'future') {
          this.$router.push('/notifications/future/' + this.page)
        } else {
          this.$store.dispatch('getNotificationList', {mode: this.mode, offset: (this.page - 1) * 10, limit: 10})
        }
      },
      editNotification (id) {
        this.$router.push('/notifications/edit/' + id)
      },
      deleteNotification (id) {
        this.deleteDialog = true
        this.deleteNotificationId = id
      },
      deleteNotificationCancel () {
        this.deleteDialog = false
        this.deleteNotificationId = null
      },
      deleteNotificationConfirm () {
        this.deleteDialog = false
        this.$store.dispatch('deleteNotification', {id: this.deleteNotificationId})
        this.deleteNotificationId = null
        this.$store.dispatch('getNotificationList', {mode: this.mode, offset: (this.page - 1) * 10, limit: 10})
      },
      onCreated () {
        if (typeof this.$route.params.page !== 'undefined') {
          this.page = parseInt(this.$route.params.page)
        } else {
          this.page = 1
        }
        if (~this.$router.currentRoute.path.indexOf('/notifications/future')) {
          this.mode = 'future'
          this.title = 'Планируемые сообщения'
        } else if (~this.$router.currentRoute.path.indexOf('/notifications/past')) {
          this.mode = 'past'
          this.title = 'Архив сообщений'
        }
        this.$store.commit('setPageLoading', true)
        this.$store.commit('setPageTitle', this.title)
        this.$store.dispatch('getNotificationList', {mode: this.mode, offset: (this.page - 1) * 10, limit: 10})
          .then(() => {
            this.pageDataReady.notificationList = true
            this.pageDataStatus()
          })
      }
    },
    computed: {
      notificationList () {
        return this.$store.getters.notificationList
      },
      totalCount () {
        return this.$store.getters.notificationTotalCount
      },
      pages () {
        let pages = this.totalCount / 10
        if ((pages ^ 0) !== pages) {
          pages = Math.floor(pages) + 1
        }
        return pages
      }
    },
    created () {
      this.onCreated()
    },
    watch: {
      '$route' (to, from) {
        this.onCreated()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Notifications/NotificationList.vue